import { useContext } from "react";
import { useQuery } from "react-query";
import { ApiContext } from "../contexts/ApiContext";

export function useAddressById(addressId?: number) {
  const apiContext = useContext(ApiContext);

  return useQuery({
    queryKey: ["addressById", addressId],
    queryFn: async () => {
      if (addressId) return await apiContext.addressApis.getAddressById(addressId);
    },
  });
}
